module.exports = __webpack_public_path__ + "static/img/icon10.554688db.png";